module.exports = __webpack_public_path__ + "img/fan_control_green.3be10475.svg";